import { Suspense } from 'react'

import { getServiceWrapper } from 'core/service-wrapper'

import ProductBenefitsSummary from './product-benefits-summary'

const renderGraph = (basicPlanCode) => {
  const serviceWrapper = getServiceWrapper()

  const className = `graph-${basicPlanCode}`
  return (
    <Suspense fallback={null}>
      {(() => {
        switch (basicPlanCode) {
          case 'R08F':
            return serviceWrapper.renderGraph('R08F', className)
          case 'R60F':
            return serviceWrapper.renderGraph('R60F', className)
          case 'R9506M1':
            return serviceWrapper.renderGraph('R9506M1', className)
          case 'R9506M2':
            return serviceWrapper.renderGraph('R9506M2', className)
          case 'R9506M3':
            return serviceWrapper.renderGraph('R9506M3', className)
          case 'R9506M4':
            return serviceWrapper.renderGraph('R9506M4', className)
          case 'R9555M':
            return serviceWrapper.renderGraph('R9555M', className)
          case 'R9560M':
            return serviceWrapper.renderGraph('R9560M', className)
          case 'R9565M':
            return serviceWrapper.renderGraph('R9565M', className)
          case 'R9570M':
            return serviceWrapper.renderGraph('R9570M', className)
        }
      })()}
    </Suspense>
  )
}

const ProductBenefits = ({
  displayProduct,
  sumAssured,
  basicPremium,
  calculatedPaymentPeriod,
  calculatedCoveragePeriod,
  policyValue,
  benefitSummaryHeader,
  showGraph = true,
}) => {
  return (
    <div id="product-benefits" className="benefit group">
      <ProductBenefitsSummary
        displayProduct={displayProduct}
        sumAssured={sumAssured}
        basicPremium={basicPremium}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        policyValue={policyValue}
        benefitSummaryHeader={benefitSummaryHeader}
      />
      {showGraph && displayProduct ? renderGraph(displayProduct.basicPlanCode) : ''}
    </div>
  )
}

export default ProductBenefits
